import { reduxSetter } from '../../../../utils/reduxSetter';
import {
    CHECK_PERMISSION_REQUEST_SUCCESS,
    CHECK_PERMISSION_REQUEST_FAILURE,
    CHECK_LAST_ROUTE_REQUEST_FAILURE,
    CHECK_PERMISSION_FOR_VIEW_REQUEST,
    CHECK_PERMISSION_FOR_VIEW_REQUEST_SUCCESS,
    CHECK_PERMISSION_FOR_VIEW_REQUEST_FAILURE,
    CHECK_PERMISSION_FOR_FIELD_REQUEST,
    CHECK_PERMISSION_FOR_FIELD_REQUEST_SUCCESS,
    CHECK_PERMISSION_FOR_FIELD_REQUEST_FAILURE,
} from '../constants/check_last_route_and_permission.constants';

import { GET_INITIAL_DATA_REQUEST, GET_INITIAL_DATA_REQUEST_SUCCESS } from '../constants/user_info.constants';

const initialState = {
    loading: false,
    filteredByPermissionsRoutes: null,
    views_permissions: null,
    fields_permissions: null,
    is_data_ready: false,
    allowedUrls: {},
    error: null,
};

export const Permissions = (state = initialState, {
    type, prefix, error, payload,
}) => {
    switch (type) {
    case 'SET_PERMISSIONS_DATA':
        return reduxSetter(state, { payload });
    case GET_INITIAL_DATA_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_INITIAL_DATA_REQUEST_SUCCESS:
        return {
            ...state,
            is_data_ready: true,
            loading: false,
        };
    case CHECK_PERMISSION_REQUEST_SUCCESS:
        return {
            ...state,
            filteredByPermissionsRoutes: payload,
        };

    case CHECK_PERMISSION_FOR_VIEW_REQUEST:
    case CHECK_PERMISSION_FOR_FIELD_REQUEST:
        return {
            ...state,
            loading: true,
        };

    case CHECK_PERMISSION_FOR_VIEW_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            views_permissions: Object.assign({}, state.views_permissions, payload),
        };

    case CHECK_PERMISSION_FOR_FIELD_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            fields_permissions: { ...payload },
        };

    case 'RESET_PERMISSIONS':
        return {
            ...state,
            views_permissions: null,
        };

    case CHECK_PERMISSION_REQUEST_FAILURE:
    case CHECK_PERMISSION_FOR_VIEW_REQUEST_FAILURE:
    case CHECK_PERMISSION_FOR_FIELD_REQUEST_FAILURE:
    case CHECK_LAST_ROUTE_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/check_permission.reducer.js